/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  getCampaignHistory(conversationId, { before, signal } = {}) {
    return axios.get(`${this.url}/${conversationId}/campaign_history`, {
      params: { before },
      signal,
    });
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getSuggestions(conversationID, type) {
    return axios.get(`${this.url}/${conversationID}/suggestions/${type}`);
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  getWorkspaceStatus() {
    return axios.get(`${this.url}/workspace_status`);
  }
}

export default new ConversationApi();
